[{
        "coreStep": "Quote Presentation",
        "generalTask": "Quote Preparation",
        "actionDetails": "<ul><li>Review quotes, manage subjectivities and alternative structures<ul><li><b>Secure market agreement to contractual language for all subjectivities and non-concurrencies prior to presenting to Client.<\/b><\/li><\/ul><\/li><li> Summarize quotes and any conditions for presentation to Client including identifying expiration of authorizations of individual markets<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "No",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?UniqueId=fe24d972%2D0abc%2D4437%2Da00b%2De78f08e75de7\" target=\"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    },
    {
        "coreStep": "Quote Presentation",
        "generalTask": "SPOE",
        "actionDetails": "<ul><li>Quote Sheet to be submitted for SPOE approval by authorized SPOE prior to sending to the Client<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href='https://ajg0.sharepoint.com/sites/gre-Gateway/_layouts/15/download.aspx?UniqueId=b2690527%2Deb94%2D4938%2D917c%2D548936b13995', target = \"_self\">GEM Authorized Second Pair of Eyes List<\/a>"
    },
    {
        "coreStep": "Quote Presentation",
        "generalTask": "Send to Client",
        "actionDetails": "<ul><li>Copy contract drafter and Ops Specialist<\/li><li>Send quotes to Client using Template Text<\/li><\/ul>",
        "responsibility": "BT\/OS\/OD",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    }
]
